export default "__VITE_ASSET__BT_dmCk5__"